import { useEffect, useRef, useState } from "react";
import { useNavbar } from "../context/NavbarContext";
import { MENU_SECTION_ENUM } from "../utils/enums";

export default function Navbar() {
  const [isFixed, setIsFixed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navbarRef = useRef(null);
  const { hideNavbar, activeSection } = useNavbar();

  useEffect(() => {
    const handleScroll = () => {
      if (navbarRef.current) {
        const { top } = navbarRef.current.getBoundingClientRect();

        if (top <= 0 && !isFixed) setIsFixed(true);
        if (top > 0 && isFixed) setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFixed]);

  const handleClick = (sectionId) => {
    setIsOpen(false);
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleBurgerClick = () => setIsOpen((prev) => !prev);

  return (
    <div className="xpb-navbar__container" ref={navbarRef}>
      <nav
        className={`xpb-navbar__nav ${hideNavbar ? "hidden" : ""}`}
        style={{
          position: isFixed ? "fixed" : "relative",
        }}
      >
        <ul className={isOpen ? "active" : ""}>
          <li>
            <span aria-label="Ir a cambiemos la narrativa">
              Cambiemos <span>la narrativa</span>
            </span>
          </li>
          <li
            className={
              activeSection === MENU_SECTION_ENUM.BEFORE_START ? "active" : ""
            }
          >
            <button
              onClick={() => handleClick("xpb-before-start")}
              aria-label="Ir a antes de empezar"
            >
              Antes de empezar
            </button>
          </li>
          <li
            className={
              activeSection === MENU_SECTION_ENUM.CONSIDER ? "active" : ""
            }
          >
            <button
              onClick={() => handleClick("xpb-consider")}
              aria-label="Ir a lineamientos"
            >
              Lineamientos
            </button>
          </li>
          <li>
            <button
              onClick={() => handleClick("xpb-design")}
              aria-label="Ir a diseña una estrategia"
            >
              Diseña una estrategia
            </button>
          </li>
        </ul>
        <button className="xpb-navbar__burger" onClick={handleBurgerClick} />
      </nav>
    </div>
  );
}
